import { GPTGroupListExportType } from '@app/interfaces/gpt-metric.type';
import { GPTAllIntegrationListObjectType } from '@app/interfaces/settings.type';
import { useImportGptChatGroupMutation } from '@app/store/api/chat-api/gpt-metric-chat.api';
import { useImportGptGroupMutation } from '@app/store/api/gpt-metric.api';
import { formBaseButtonBlockStyles } from '@app/styles/base-styles';
import { Button, Upload } from '@ui';
import classNames from 'classnames';
import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';

const ImportGptGroupContent: FC<{
  setImportModalState: React.Dispatch<React.SetStateAction<boolean>>;
  project_id: string;
  currentTemplate: 'chat' | 'voice';
  gptModelsList: GPTAllIntegrationListObjectType | undefined;
  circleButtonClick: (metric_id: string, type: string, copy?: boolean) => void;
}> = ({ setImportModalState, project_id, gptModelsList, circleButtonClick, currentTemplate }) => {
  const [importGPTGroupVoice] = useImportGptGroupMutation();
  const [importGPTGroupChat] = useImportGptChatGroupMutation();
  const importGPTGroup = { chat: importGPTGroupChat, voice: importGPTGroupVoice }[currentTemplate];

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const isDefaultModel =
    gptModelsList?.default_gpt_integrations
      .find((model) => model.is_default === true)
      ?.default_integration_id.toString() ||
    gptModelsList?.gpt_integrations.find((model) => model.is_default === true)?.gpt_integration_id;
  // exclude_begin_sec <=> exclude_begin_messages
  // exclude_end_sec <=> exclude_end_messages
  // search_begin_sec <=> search_end_messages
  // search_end_sec <=> search_end_messages

  const keyMapChat: { [key: string]: string } = {
    exclude_begin_sec: 'exclude_begin_messages',
    exclude_end_sec: 'exclude_end_messages',
    search_begin_sec: 'search_end_messages',
    search_end_sec: 'search_end_messages',
  };

  const keyMapVoice = Object.fromEntries(Object.entries(keyMapChat).map(([k, v]) => [v, k]));

  function replaceKeysDeep(obj: GPTGroupListExportType, map): Record<string, any> {
    if (Array.isArray(obj)) {
      // return obj.map((item) => replaceKeysDeep(item, map));
      return obj;
    } else if (obj !== null && typeof obj === 'object') {
      const newObj = {};
      for (const key in obj) {
        const newKey = map[key] || key; // если есть замена, используем ее
        newObj[newKey] = replaceKeysDeep(obj[key], map);
      }
      return newObj;
    } else {
      return obj;
    }
  }
  function handleImportFiles() {
    const reader = new FileReader();
    reader.readAsText(uploadedFiles[0]);
    reader.onload = function (e) {
      const parsed = JSON.parse(e?.target?.result as string);
      const contents = {
        ...parsed,
        gpt_group: {
          ...parsed.gpt_group,
          name: parsed.gpt_group.name + '0',
        },
      } as GPTGroupListExportType;
      let result;
      switch (currentTemplate) {
        case 'chat':
          result = replaceKeysDeep(contents, keyMapChat);
          break;
        case 'voice':
          result = replaceKeysDeep(contents, keyMapVoice);
          break;

        default:
          break;
      }

      const import_file = JSON.stringify(result);
      const import_file_blob = new Blob([import_file], { type: 'application/json' });

      const gpt_integration = JSON.stringify({
        gpt_integration_id:
          isDefaultModel ||
          gptModelsList?.gpt_integrations?.[gptModelsList?.gpt_integrations?.length - 1]
            ?.gpt_integration_id,
        type: 'user',
      });

      const formData = new FormData();

      formData.append('project_id', project_id);
      formData.append('import_file', import_file_blob);
      currentTemplate === 'chat'
        ? formData.append('c_role', 'all')
        : formData.append('channel', 'all');
      formData.append('gpt_integration', gpt_integration);

      importGPTGroup(formData)
        .unwrap()
        .then((data) => {
          toast.success('Успешно');
          circleButtonClick(data.gpt_group_id, 'gpt');
        })
        .catch(() => toast.error('Ошибка'))
        .finally(() => setImportModalState(false));
    };
  }

  return (
    <div>
      <Upload
        loadedFiles={uploadedFiles}
        fileAccept=".json"
        multiple={false}
        changeLoadedFiles={setUploadedFiles}
      />
      <div className={classNames(formBaseButtonBlockStyles, 'pb-[20px] !pt-[20px]')}>
        <Button
          disabled={!uploadedFiles.length}
          onClick={handleImportFiles}
          label={'Импортировать'}
        />
        <Button onClick={() => setImportModalState?.(false)} label={'Отмена'} fill="linked" />
      </div>
    </div>
  );
};

export default ImportGptGroupContent;
